import React, { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { isInternalUrl } from '../../../../../utils';
import { TLinkWithField } from '../../types/cta.types';
import ArrowRight from './arrowRight';

const ValidHrefAndNotEditing: FC<TLinkWithField> = ({ field, type, children, hasArrowRight, ctaClassName, onClick }) => {
  const value = field.value;

  // determine if a link is a route or not. This logic may not be appropriate for all usages.
  if (value.href && isInternalUrl(value.href)) {
    return (
      <RouterLink to={value.href} title={value.title} target={value?.target} className={ctaClassName ?? value.class} onClick={onClick}>
        {children || value.text || value.href}
        {hasArrowRight && <ArrowRight type={type} />}
      </RouterLink>
    );
  }
  return null;
};

export default ValidHrefAndNotEditing;
